import { cloneElement, isValidElement, type ReactElement } from "react";
import { EmailNode } from "@react-email/editor/core";
import { Button } from "@react-email/editor/extensions";

/**
 * react-email renders a button as Row > Column > <a>, with no space around it,
 * so the next block butts right up against it. Pad the bottom of the Column's
 * <td>: padding on a table cell is honoured by every client, including desktop
 * Outlook, which ignores margin on the <a>. The block above already ends with
 * the paragraph gap, so only the bottom needs it. Mirrored by the editor CSS in
 * index.css (block gaps the email theme cannot reach).
 */
export const BUTTON_GAP = "14px";

type Render = NonNullable<(typeof Button)["config"]["renderToReactEmail"]>;
const render = Button.config.renderToReactEmail as Render;

export const SpacedButton = EmailNode.from(Button as unknown as Parameters<typeof EmailNode.from>[0], (props: Parameters<Render>[0]) => {
    const row = render(props) as ReactElement<{ children?: unknown }>;
    const column = row.props.children;
    if (!isValidElement<{ style?: object }>(column)) return row;
    return cloneElement(row, undefined, cloneElement(column, {
        style: { ...column.props.style, paddingBottom: BUTTON_GAP },
    }));
});
